import React, { FC } from 'react';

const MortgageChoiceLogo: FC = () => (
  <svg
    width="127px"
    height="20px"
    viewBox="134 15 300 80"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#5AE2E0"
      d="m56.07 45.93s10.71-14.91 22.02-14.91c3.77 0 6.32 1.78 6.57 4.26 0.26 2.55-1.22 5.73-6.32 5.39-3.57-0.23-15.99-2.3-23.87 12.12 0 0-0.54-9.38-5.43-14.89-2.59-2.92-2.32-5.62 0.27-7.23 0 0 4.35-2.21 5.7 4.46 0.6 2.98 1.52 7.68 1.06 10.8"
    />
    <path
      fill="#E4002B"
      d="m53.1 58.81s7.06-16.3 26.57-13.67c3.29 0.44 5.42 2.68 5.12 5.95-0.33 3.69-4.56 4.54-8.19 3.55-12.28-3.37-17.41-1.84-24.54 8.72-2.32-12.98-10.52-14.88-13.1-18.83-0.83-1.26-1.31-3.6 0.15-5.01s3.68-1.66 5.33-0.38c3.35 2.64 8.09 13.55 8.66 19.67z"
    />
    <path
      fill="#006875"
      d="m49.93 74.42s0.55-13.17-16.47-18.56c-2.67-0.85-4.3-4.03-3.14-6.24 1.12-2.13 4.21-2.54 7.08-1.1 10.13 5.1 13.53 19.47 13.53 19.47 8.51-12.6 21.78-10.96 27.62-9.46 5.98 1.53 6.9 5.42 5.9 8.07-0.95 2.55-4.27 4.17-10.18 1.16-0.51-0.23-16.55-8.89-24.34 6.66z"
    />
    <path
      fill="#006875"
      d="m129.19 29.95h7.41v40.22h-7.87v-27.7l-11.03 15.11h-1.32l-11.15-15.11v27.69h-7.81v-40.21h7.41l12.3 16.89 12.06-16.89z"
    />
    <path
      fill="#006875"
      d="m141.63 55.34c0-9.14 6.49-15.46 15.23-15.46 8.85 0 15.34 6.32 15.34 15.46 0 9.19-6.49 15.51-15.34 15.51-8.74 0.01-15.23-6.31-15.23-15.51zm22.98 0c0-5.63-3.33-8.85-7.76-8.85-4.37 0-7.64 3.22-7.64 8.85 0 5.69 3.28 8.96 7.64 8.96 4.43 0.01 7.76-3.27 7.76-8.96z"
    />
    <path
      fill="#006875"
      d="m193.13 39.89v7.93h-3.1c-3.45 0-5.92 2.47-5.92 6.84v15.51h-7.41v-29.59h7.41v4.25c1.67-3.45 4.37-4.94 7.47-4.94h1.55z"
    />
    <path
      fill="#006875"
      d="m214.06 46.49h-6.61v13.04c0 2.82 1.15 4.25 3.45 4.25h3.16v6.38h-4.08c-6.32 0-9.94-3.97-9.94-10.29v-13.38h-5.4v-5.92h5.4v-5.69l7.41-4.08v9.77h6.61v5.92z"
    />
    <path
      fill="#006875"
      d="m237.62 40.58h7.41v25.74c0 9.14-6.15 14.42-15.17 14.42-4.66 0-10.63-2.18-13.5-8.16l5.52-3.68c1.72 3.16 4.66 5.34 8.16 5.34 4.14 0 7.58-2.47 7.58-7.53v-3.5c-1.72 2.64-4.42 4.6-8.62 4.6-7.3 0-12.7-6.03-12.7-13.96s5.4-13.96 12.7-13.96c4.19 0 6.9 1.95 8.62 4.65v-3.96zm0.12 13.27c0-4.42-2.87-7.41-6.9-7.41-4.14 0-7.01 2.99-7.01 7.41 0 4.43 2.88 7.41 7.01 7.41 4.03 0 6.9-2.99 6.9-7.41z"
    />
    <path
      fill="#006875"
      d="m276.37 51.55v18.62h-6.9v-2.87c-1.78 2.36-4.83 3.56-8.73 3.56-6.89 0-11.43-3.45-11.43-9.25 0-5.57 4.71-9.19 11.95-9.19 3.39 0 5.98 0.98 7.7 2.59v-2.7c0-3.97-2.3-5.8-6.15-5.8-3.28 0-5.52 1.72-6.61 4.71l-6.15-2.58c2.01-6.26 7.18-8.73 13.04-8.73 7.13-0.02 13.28 3.66 13.28 11.64zm-7.24 10c0-2.53-2.47-3.97-6.09-3.97s-6.09 1.44-6.09 3.97 2.47 3.91 6.09 3.91 6.09-1.38 6.09-3.91z"
    />
    <path
      fill="#006875"
      d="m301.9 40.58h7.41v25.74c0 9.14-6.15 14.42-15.17 14.42-4.65 0-10.63-2.18-13.5-8.16l5.52-3.68c1.72 3.16 4.66 5.34 8.16 5.34 4.14 0 7.58-2.47 7.58-7.53v-3.5c-1.72 2.64-4.42 4.6-8.62 4.6-7.3 0-12.7-6.03-12.7-13.96s5.4-13.96 12.7-13.96c4.19 0 6.9 1.95 8.62 4.65v-3.96zm0.11 13.27c0-4.42-2.88-7.41-6.9-7.41-4.14 0-7.01 2.99-7.01 7.41 0 4.43 2.87 7.41 7.01 7.41 4.03 0 6.9-2.99 6.9-7.41z"
    />
    <path
      fill="#006875"
      d="m342.14 57.01h-20.86c0.46 5.23 3.22 7.53 7.01 7.53 3.5 0 6.03-1.61 7.58-5.63l6.26 2.3c-2.3 6.67-7.53 9.65-13.56 9.65-8.73 0-14.82-6.21-14.82-15.51 0-9.19 5.97-15.46 14.48-15.46 8.22 0 13.96 6.2 13.96 15.4 0 0.51 0 1.2-0.05 1.72zm-20.63-5.06h13.16c-0.8-4.19-3.16-6.09-6.43-6.09-3.63 0-5.93 2.01-6.73 6.09z"
    />
    <path
      fill="#006875"
      d="m356.75 50.06c0-12.35 8.39-20.8 20.17-20.8 8.68 0 15.4 4.59 17.98 12.81l-7.18 2.64c-1.78-5.11-5.63-8.27-10.8-8.27-6.95 0-11.95 5.11-11.95 13.62s5 13.62 11.95 13.62c5.17 0 9.02-3.16 10.8-8.27l7.18 2.64c-2.58 8.22-9.31 12.81-17.98 12.81-11.78 0-20.17-8.45-20.17-20.8z"
    />
    <path
      fill="#006875"
      d="m424.58 51.09v19.08h-7.41v-17.81c0-3.85-2.18-6.03-5.17-6.03-3.51 0-6.03 2.36-6.03 6.44v17.41h-7.41v-40.23h7.41v14.48c1.78-3.22 4.77-4.54 8.1-4.54 6.03 0 10.51 4.42 10.51 11.2z"
    />
    <path
      fill="#006875"
      d="m428.79 55.34c0-9.14 6.49-15.46 15.23-15.46 8.85 0 15.34 6.32 15.34 15.46 0 9.19-6.49 15.51-15.34 15.51-8.74 0.01-15.23-6.31-15.23-15.51zm22.98 0c0-5.63-3.33-8.85-7.76-8.85-4.37 0-7.64 3.22-7.64 8.85 0 5.69 3.28 8.96 7.64 8.96 4.43 0.01 7.76-3.27 7.76-8.96z"
    />
    <path
      fill="#006875"
      d="m462.82 32.76c0-2.76 2.13-4.48 4.77-4.48s4.77 1.72 4.77 4.48c0 2.81-2.12 4.42-4.77 4.42s-4.77-1.6-4.77-4.42zm8.45 7.82v29.59h-7.41v-29.59h7.41z"
    />
    <path
      fill="#006875"
      d="m475.76 55.34c0-9.25 6.44-15.46 14.82-15.46 6.55 0 12.18 3.28 14.13 10.51l-6.55 2.36c-1.44-4.54-3.85-6.32-7.58-6.32-3.74 0-7.18 2.93-7.18 8.91 0 5.97 3.45 8.91 7.18 8.91s6.15-1.72 7.58-6.26l6.55 2.36c-1.95 7.24-7.58 10.52-14.13 10.52-8.38-0.01-14.82-6.28-14.82-15.53z"
    />
    <path
      fill="#006875"
      d="m535.59 57.01h-20.86c0.46 5.23 3.22 7.53 7.01 7.53 3.5 0 6.03-1.61 7.58-5.63l6.26 2.3c-2.3 6.67-7.53 9.65-13.56 9.65-8.73 0-14.82-6.21-14.82-15.51 0-9.19 5.97-15.46 14.48-15.46 8.22 0 13.96 6.2 13.96 15.4 0.01 0.51 0.01 1.2-0.05 1.72zm-20.63-5.06h13.16c-0.8-4.19-3.16-6.09-6.43-6.09-3.62 0-5.92 2.01-6.73 6.09z"
    />
    <g display="none">
      <path
        display="inline"
        opacity="0.37"
        fill="#0000FF"
        d="m14.18 53.66c-0.11 19.52 15.63 35.43 35.15 35.53 19.52 0.11 35.43-15.63 35.53-35.16 0.1-19.51-15.63-35.42-35.15-35.52h-0.2c-19.42 0-35.23 15.7-35.33 35.15z"
      />
      <g display="inline" opacity="0.41">
        <path
          fill="#0000FF"
          d="m61.88 74.45h-24.71c-1.95 0-3.54-1.59-3.54-3.54v-14.53h-2.96c-1.44 0-2.72-0.86-3.27-2.18-0.55-1.33-0.25-2.84 0.76-3.86l18.86-18.95c0.66-0.66 1.57-1.04 2.51-1.04s1.85 0.38 2.51 1.04l18.86 18.94c1.01 1.02 1.31 2.54 0.76 3.86-0.55 1.33-1.84 2.18-3.27 2.18h-2.96v14.53c0 1.96-1.59 3.55-3.55 3.55zm-12.35-41.04c-0.13 0-0.25 0.05-0.33 0.14l-18.87 18.95c-0.13 0.14-0.18 0.34-0.1 0.51 0.07 0.18 0.25 0.29 0.44 0.29h4.5c0.85 0 1.54 0.69 1.54 1.54v16.07c0 0.26 0.21 0.47 0.47 0.47h24.71c0.26 0 0.47-0.21 0.47-0.47v-16.07c0-0.85 0.69-1.54 1.54-1.54h4.5c0.19 0 0.36-0.11 0.44-0.29 0.07-0.18 0.03-0.38-0.1-0.52l-18.88-18.94c-0.09-0.09-0.21-0.14-0.33-0.14z"
        />
      </g>
    </g>
  </svg>
);

export default MortgageChoiceLogo;
